import { useEffect, useState } from "react";

export default function LoadingScreen() {
  const [message, setMessage] = useState("Preparing your experience...");

  useEffect(() => {
    const messages = [
      "Gathering tranquil moments...",
      "Brewing a cup of digital calm...",
      "Aligning peaceful pixels...",
      "Whispering to the data fairies...",
      "Massaging the stressed-out bytes...",
    ];

    const interval = setInterval(() => {
      setMessage(messages[Math.floor(Math.random() * messages.length)]);
    }, 4000);

    return () => clearInterval(interval);
  }, []);

  return (
    <div className="tw-h-screen tw-flex tw-items-center tw-justify-center tw-bg-gradient-to-br tw-from-blue-100 tw-to-green-100">
      <div className="tw-w-full tw-max-w-md tw-p-8 tw-bg-white tw-bg-opacity-80 tw-backdrop-blur-md tw-rounded-lg tw-shadow-lg tw-space-y-6">
        <div className="tw-relative tw-w-24 tw-h-24 tw-mx-auto">
          <div className="tw-absolute tw-inset-0 tw-border-4 tw-border-blue-200 tw-rounded-full tw-animate-ping"></div>
          <div
            className="tw-absolute tw-inset-2 tw-border-4 tw-border-blue-400 tw-rounded-full tw-animate-ping"
            style={{ animationDelay: "1s" }}
          ></div>
          <div
            className="tw-absolute tw-inset-4 tw-border-4 tw-border-blue-600 tw-rounded-full tw-animate-ping"
            style={{ animationDelay: "2s" }}
          ></div>
        </div>

        <h2 className="tw-text-2xl tw-font-semibold tw-text-center tw-text-blue-800">
          Just a moment, please
        </h2>

        <p className="text-center text-blue-600">{message}</p>

        <div className="tw-relative tw-w-full tw-h-2 tw-bg-blue-200 tw-rounded-full tw-overflow-hidden">
          <div className="relative tw-w-full tw-h-4 tw-bg-teal-100 tw-rounded-full tw-overflow-hidden">
            <div
              className="absolute tw-top-0 tw-left-0 tw-h-full tw-bg-teal-500 tw-rounded-full tw-transition-all tw-duration-100 tw-ease-in-out"
              style={{ width: `0%` }}
            ></div>
          </div>
        </div>

        <p className="text-sm text-center text-blue-500">
          This might take some time. Feel free to take a deep breath and relax.
        </p>
      </div>
    </div>
  );
}
